import { ICommonAppConfig } from '../../../Common/app/app.config.token';

import { AuthenticationMeetingsComponent } from './authentication.meetings.component';

export const authenticationMeetingsAppConfig: ICommonAppConfig = {
	application: 'meetings_auth',
	hasInitialLoader: false,
	shouldAuthorize: false,
	mainComponent: AuthenticationMeetingsComponent,
	shouldInitLayoutService: false,
};
